import { render, staticRenderFns } from "./initial-organization-update-modal.vue?vue&type=template&id=078519f7&scoped=true"
import script from "./initial-organization-update-modal.vue?vue&type=script&lang=js"
export * from "./initial-organization-update-modal.vue?vue&type=script&lang=js"
import style0 from "./initial-organization-update-modal.vue?vue&type=style&index=0&id=078519f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078519f7",
  null
  
)

export default component.exports